/**
 * Search matching utilities - OPTIMIZED
 * Case-insensitive substring matching with normalization
 */
import { RELEVANCE_SCORES } from '../constants'

/**
 * Normalize text for case-insensitive comparison
 * Handles special characters: '—' (em dash), ':' (colon)
 */
export const normalizeText = (text: string | undefined | null): string => {
  if (!text) return ''
  return text.toLowerCase().replace(/—/g, '-').replace(/:/g, '').trim()
}

/**
 * Check if normalized text contains normalized term
 * OPTIMIZED: Expects pre-normalized term
 */
export const containsNormalized = (
  text: string | undefined | null,
  normalizedTerm: string
): boolean => {
  if (!normalizedTerm) return false
  return normalizeText(text).includes(normalizedTerm)
}

/**
 * Calculate relevance score - OPTIMIZED
 * Expects pre-normalized term, normalizes name/codes once
 */
export const calculateRelevanceOptimized = (
  name: string | undefined,
  originalCodes: string | undefined,
  normalizedTerm: string,
  lv2Matched: boolean,
  lv3Matched: boolean
): number => {
  let score = 0
  const normalizedName = normalizeText(name)
  const normalizedCodes = normalizeText(originalCodes)

  // Code matching (highest priority)
  if (normalizedCodes === normalizedTerm) {
    score += RELEVANCE_SCORES.CODE_EXACT
  } else if (normalizedCodes.startsWith(normalizedTerm)) {
    score += RELEVANCE_SCORES.CODE_STARTS
  } else if (normalizedCodes.includes(normalizedTerm)) {
    score += RELEVANCE_SCORES.CODE_CONTAINS
  }

  // Name matching
  if (normalizedName.startsWith(normalizedTerm)) {
    score += RELEVANCE_SCORES.NAME_STARTS
  } else if (normalizedName.includes(normalizedTerm)) {
    score += RELEVANCE_SCORES.NAME_CONTAINS
  }

  // Ancestor match bonuses
  if (lv2Matched) score += RELEVANCE_SCORES.LV2_MATCH_BONUS
  if (lv3Matched) score += RELEVANCE_SCORES.LV3_MATCH_BONUS

  return score
}
